"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var __aws_sdk_bucket_endpoint_middleware = require("@aws-sdk/bucket-endpoint-middleware");
var __aws_sdk_middleware_stack = require("@aws-sdk/middleware-stack");
var PutObjectTagging_1 = require("../model/PutObjectTagging");
var PutObjectTaggingCommand = /** @class */ (function () {
    function PutObjectTaggingCommand(input) {
        this.input = input;
        this.model = PutObjectTagging_1.PutObjectTagging;
        this.middlewareStack = new __aws_sdk_middleware_stack.MiddlewareStack();
    }
    PutObjectTaggingCommand.prototype.resolveMiddleware = function (clientStack, configuration) {
        var handler = configuration.handler;
        var stack = clientStack.concat(this.middlewareStack);
        var handlerExecutionContext = {
            logger: {},
            model: this.model
        };
        stack.add(__aws_sdk_bucket_endpoint_middleware.bucketEndpointMiddleware({
            forcePathStyle: configuration.forcePathStyle,
            preformedBucketEndpoint: configuration.bucketEndpoint,
            useAccelerateEndpoint: configuration.useAccelerateEndpoint,
            useDualstackEndpoint: configuration.useDualstackEndpoint
        }), {
            step: "build",
            priority: 0
        });
        return stack.resolve(handler(handlerExecutionContext), handlerExecutionContext);
    };
    return PutObjectTaggingCommand;
}());
exports.PutObjectTaggingCommand = PutObjectTaggingCommand;
//# sourceMappingURL=PutObjectTaggingCommand.js.map